import { Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

// provides auto-complete related utility functions

@Injectable()
export class AutoComplete {
	public source: string;
	public pathToData: string;
	public listFormatter: (arg: any) => string;

	constructor(@Optional() private readonly http: HttpClient) {}

	filter(list: any[], keyword: string, matchFormatted: boolean, matchWords: string) {
		return list.filter(el => {
			const objStr = matchFormatted ? this.getFormattedListItem(el).toLowerCase() : JSON.stringify(el).toLowerCase();
			keyword = keyword.toLowerCase();
			if (matchWords) {
				return objStr.indexOf(keyword) === 0 || objStr.indexOf(matchWords.toLowerCase() + ' ' + keyword) === 0;
			}
			return matchFormatted ? objStr.indexOf(keyword) === 0 : objStr.indexOf(keyword) !== -1;
		});
	}

	getFormattedListItem(data: any) {
		let formatted: any;
		const formatter: any = this.listFormatter || '(id) value';
		if (typeof formatter === 'function') {
			formatted = formatter.apply(this, [data]);
		} else if (typeof data !== 'object') {
			formatted = data;
		} else if (typeof formatter === 'string') {
			formatted = formatter;
			const matches = formatter.match(/[a-zA-Z0-9_\$]+/g);
			if (matches && typeof data !== 'string') {
				matches.forEach((key: any) => {
					formatted = formatted.replace(key, data[key]);
				});
			}
		}
		return formatted;
	}

	// return remote data from the given source and options, and data path

	getRemoteData(keyword: string): Observable<any> {
		if (typeof this.source !== 'string') {
			throw new Error('Invalid type of source, must be a string. e.g. http://www.google.com?q=:my_keyword');
		} else if (!this.http) {
			throw new Error('Http is required.');
		}

		const matches = /:[a-zA-Z_]+/.exec(this.source);
		if (!matches) {
			throw new Error('Replacement word is missing.');
		}

		const replacementWord = matches[0];
		const url = this.source.replace(replacementWord, keyword);

		return this.http
			.get(url)
			.pipe(map((resp: any) => resp.json()))
			.pipe(map((resp: any) => {
				let list = resp.data ?? resp;

				if (this.pathToData) {
					const paths = this.pathToData.split('.');
					paths.forEach(prop => (list = list[prop]));
				}

				return list;
			}));
	}
}
